import { jsxs as i, jsx as l } from "react/jsx-runtime";
function h(t) {
  return /* @__PURE__ */ i(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "25",
      height: "25",
      viewBox: "0 0 25 25",
      fill: "none",
      ...t,
      children: [
        /* @__PURE__ */ i("g", { "clip-path": "url(#clip0_16011_9270)", children: [
          /* @__PURE__ */ l(
            "path",
            {
              d: "M24.2663 12.7765C24.2663 11.9608 24.2001 11.1406 24.059 10.3381H12.7402V14.9591H19.222C18.953 16.4495 18.0888 17.7679 16.8233 18.6056V21.604H20.6903C22.9611 19.514 24.2663 16.4274 24.2663 12.7765Z",
              fill: "#4285F4"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              d: "M12.74 24.5008C15.9764 24.5008 18.7058 23.4382 20.6944 21.6039L16.8274 18.6055C15.7516 19.3375 14.3626 19.752 12.7444 19.752C9.61376 19.752 6.95934 17.6399 6.00693 14.8003H2.01648V17.8912C4.05359 21.9434 8.20278 24.5008 12.74 24.5008Z",
              fill: "#34A853"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              d: "M6.00277 14.8002C5.50011 13.3099 5.50011 11.696 6.00277 10.2057V7.11475H2.01674C0.314734 10.5055 0.314734 14.5004 2.01674 17.8912L6.00277 14.8002Z",
              fill: "#FBBC04"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              d: "M12.74 5.24966C14.4508 5.2232 16.1043 5.86697 17.3433 7.04867L20.7694 3.62262C18.6 1.5855 15.7207 0.465534 12.74 0.500809C8.20277 0.500809 4.05359 3.05822 2.01648 7.11481L6.00252 10.2058C6.95052 7.36173 9.60935 5.24966 12.74 5.24966Z",
              fill: "#EA4335"
            }
          )
        ] }),
        /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "clip0_16011_9270", children: /* @__PURE__ */ l(
          "rect",
          {
            width: "24",
            height: "24",
            fill: "rgb(var(--background-secondary))",
            transform: "translate(0.5 0.5)"
          }
        ) }) })
      ]
    }
  );
}
export {
  h as GoogleLogoIcon
};
